import { createFileRoute } from '@tanstack/react-router'
import { KestrelPage } from 'pages/kestrel/KestrelHomePage'

export const Route = createFileRoute('/kestrel/')({
  component: KestrelPage,
  staticData: {
    title: 'Kestrel',
  },
})
